"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.getMenuData = getMenuData;
exports.rememberMenuState = rememberMenuState;
var _debug = _interopRequireDefault(require("debug"));
var _effects = require("redux-saga/effects");
var _SessionStorage = _interopRequireDefault(require("../../shared/SessionStorage"));
var _constants = _interopRequireDefault(require("../constants"));
var _menu = require("../utils/menu");
var _pubsub = _interopRequireDefault(require("../services/pubsub"));
var actions = _interopRequireWildcard(require("../actions"));
var _snacks = require("../services/snacks");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const info = (0, _debug.default)('AppFrame:menu');
function* getMenuData() {
  try {
    const menuAPI = yield (0, _effects.getContext)('menuApi');
    const menu = yield (0, _effects.call)(menuAPI.getData);
    info('Unordered menu data:', menu);
    const orderedSolutions = yield (0, _effects.call)(_menu.orderSolutions, menu.nodes);
    info('Ordered solutions:', orderedSolutions);
    yield (0, _effects.call)(_SessionStorage.default.set, _constants.default.MENU_KEY, orderedSolutions);
    yield (0, _effects.put)(actions.getMenuDataSuccess(orderedSolutions, menu.options));
  } catch (error) {
    info('getMenuData error:', error.message);
    const locale = yield (0, _effects.getContext)('locale');
    yield (0, _effects.put)(actions.getMenuDataError(error.message));
    yield (0, _effects.put)(actions.setSnack((0, _snacks.errorSnack)(locale.sitemapAPIError || error.message)));
  }
}
function* rememberMenuState(action) {
  yield (0, _effects.call)(_SessionStorage.default.set, _constants.default.MENU_EXPANDED, action.payload);
  _pubsub.default.publish(actions.MENU_TOGGLE, action.payload);
  info('Menu toggle:', action.payload);
}
function _default() {
  return (0, _effects.all)([(0, _effects.takeLatest)(actions.GET_MENU_DATA_PENDING, getMenuData), (0, _effects.takeLatest)(actions.MENU_TOGGLE, rememberMenuState)]);
}